var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#EBF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.9028C18.4886 12.3492 19.2035 12 20 12C21.4728 12 22.6667 13.1939 22.6667 14.6667C22.6667 16.1394 21.4728 17.3333 20 17.3333C19.2035 17.3333 18.4886 16.9842 18 16.4305M20 24H12V23.3333C12 21.1242 13.7909 19.3333 16 19.3333C18.2091 19.3333 20 21.1242 20 23.3333V24ZM20 24H24V23.3333C24 21.1242 22.2091 19.3333 20 19.3333C19.2714 19.3333 18.5883 19.5281 18 19.8685M18.6667 14.6667C18.6667 16.1394 17.4728 17.3333 16 17.3333C14.5272 17.3333 13.3333 16.1394 13.3333 14.6667C13.3333 13.1939 14.5272 12 16 12C17.4728 12 18.6667 13.1939 18.6667 14.6667Z",
    stroke: "#0041A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonNotifications);
export default __webpack_public_path__ + "static/media/person-notifications.40269b00e008c9803684846f612bb8a7.svg";
export { ForwardRef as ReactComponent };